import { Box, Typography } from '@mui/material';

import SOURCE_TYPE from '@/features/SourceCreate/SourceCreate.constants';
import type { DataSourceResponse } from '@/features/SourceCreate/SourceCreate.types';

import AwsS3DataProviders from './AwsS3DataProviders';
import GoogleStorageProviders from './GoogleStorageProviders';
import type { ViewDataProvidersProps } from './ViewDataProviders.types';

/**
 * Displays data-provider details for supported cloud source types.
 *
 * @param props Component properties.
 * @returns Data providers section.
 */
const ViewDataProviders = ({ item }: ViewDataProvidersProps) => {
  const isAwsS3Source = item?.source_type_id === SOURCE_TYPE.AWS_S3;
  const isGoogleStorageSource =
    item?.source_type_id === SOURCE_TYPE.GOOGLE_STORAGE;

  const s3Providers = (item?.connection_inputs?.s3_data_providers ??
    []) as DataSourceResponse[];
  const gcsProviders =
    (item?.connection_inputs?.data_providers as
      | Record<string, DataSourceResponse>
      | undefined) ?? {};

  return (
    <Box sx={{ m: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Data Providers
      </Typography>

      {isAwsS3Source && <AwsS3DataProviders providers={s3Providers} />}

      {isGoogleStorageSource && (
        <GoogleStorageProviders providers={gcsProviders} />
      )}
    </Box>
  );
};

export default ViewDataProviders;
